import type { FetchModelResponse } from '@cian/http-api';
import { NotFoundError } from '@cian/peperrors/shared';

import type { TGetNewbuildingsForDeveloperCardResponse } from '../../../repositories/newbuilding-search/v1/get-newbuildings-for-developer-card';
import type { IGetNewbuildingsForDeveloperCardResponse } from '../../../repositories/newbuilding-search/entities/get_newbuildings_for_developer_card/GetNewbuildingsForDeveloperCardResponse';

export function assertNotFoundError(
  response: TGetNewbuildingsForDeveloperCardResponse,
): asserts response is FetchModelResponse<200, 'json', IGetNewbuildingsForDeveloperCardResponse> {
  if (response.statusCode !== 200) {
    return;
  }

  const newbuildingsNotFound = !(response && response.response && response.response.newbuildings);

  if (!newbuildingsNotFound) {
    return;
  }

  throw new NotFoundError({
    domain: 'src/shared/services/getNewBuildings/getNewBuildings.ts',
    message: 'Empty newbuildings data',
  });
}
